import { render, staticRenderFns } from "./customerDialog.vue?vue&type=template&id=e8f59426"
import script from "./customerDialog.vue?vue&type=script&lang=js"
export * from "./customerDialog.vue?vue&type=script&lang=js"
import style0 from "./customerDialog.vue?vue&type=style&index=0&id=e8f59426&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports